import { render, staticRenderFns } from "./MyProjectsContractBaseAddress.vue?vue&type=template&id=25869a50&scoped=true"
import script from "./MyProjectsContractBaseAddress.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectsContractBaseAddress.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjectsContractBaseAddress.vue?vue&type=style&index=0&id=25869a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25869a50",
  null
  
)

export default component.exports